<div class="flex-direction-column gap-5">
  @if (label) {
    <span class="label" [style.color]="colorLabel ?? ''">
      {{ label }}
    </span>
  }

  @if (carregandoInfo) {
    <div
      class="skeleton"
      [style.width]="widthFormField"
      [style.height]="heightFormField">
    </div>

  } @else {

    <mat-form-field
      appearance="outline"
      [ngClass]="classe"
      [style.width]="widthFormField"
      [style.height]="heightFormField"
      [hideRequiredMarker]="true"
      [style.background-color]="backgroundColor ?? 'white'"
      [ngStyle]="
        isInvalid
        ? {
            border: '1px solid',
            'border-radius': '4px',
            'border-color': '#f44336'
          }
        : {
            border: '1px solid',
            'border-radius': '4px',
            'border-color': borderColor ?? 'transparent'
          }">

      @if (iconPrefix) {
        <mat-icon
          matPrefix
          [ngClass]="classe + ' prefix-icon'"
          [style.color]="iconColor ?? 'black'">
          {{ iconPrefix }}
        </mat-icon>
      }

      <mat-select
        [(ngModel)]="itemSelecionado"
        [placeholder]="placeholder"
        [disabled]="disabled"
        [compareWith]="compararListas"
        [panelClass]="panelClasses"
        (selectionChange)="onSelectionChange()">

        @if (habilitarBusca) {
          <ngx-mat-select-search
            [formControl]="filtroControl"
            placeholderLabel="Pesquisar"
            noEntriesFoundLabel="">
          </ngx-mat-select-search>
        }

        <div [class.select-options-scroll]="habilitarBusca">
          @if (desselecionar) {
            <mat-option
              [value]="null"
              [ngClass]="classe">

              <span class="span-option">
                Desselecionar
              </span>

            </mat-option>
          }

          @for (item of listaInput; track item) {

            <mat-option
              [value]="item"
              [disabled]="item['disabled']"
              [ngClass]="classe">

              <span
                class="span-option"
                [ngClass]="classe">

                {{ getDisplayText(item) }}

              </span>

            </mat-option>

          }
        </div>

      </mat-select>

    </mat-form-field>

  }

  @if (showValidationErrors && isInvalid && !carregandoInfo) {
    <div class="error-message">
      {{ getErrorMessage() }}
    </div>
  }

</div>
